import { dataExportImportCommon } from '~/lib/data/exportImportCommon';

export const useActionRefreshAssessments = () => {
  const { $db } = useNuxtApp();
  const { onPlay, complete } = useAbstractAction(
    'actionRefreshAssessments',
    false,
    1000,
    [ActionRefreshData]
  );

  const route = useRoute();

  const isAssessmentsPath = computed(() => {
    return route.path === `/${Sections.ChildForYou}`;
  });

  onPlay(async () => {
    if (isAssessmentsPath.value) {
      const { exportImportAssessments } = dataExportImportCommon(
        $db,
        useApiFetch
      );
      await exportImportAssessments();
      complete(true);
    } else {
      complete(true);
    }
  });
};
